'use client'

/**
 * Application Insights Provider
 * Initializes browser-side telemetry tracking
 */

import { useEffect } from 'react'

import { initializeAppInsights } from '@/lib/appInsights'

export default function AppInsightsProvider({ children }: { children: React.ReactNode }) {
  useEffect(() => {
    // Initialize Application Insights on client-side mount
    const result = initializeAppInsights()
    
    if (result) {
      console.log('📊 Browser telemetry active')
    }
  }, [])

  return <>{children}</>
}
